import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';

import './style.css';

class Stores extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchData:null
            ,openModal:false
            ,order:'asc'
            ,orderBy:'Name'
            ,page:0
            ,rowsPerPage:10
            ,tableLoading:false
        };
    }
    componentDidMount() {
        this.setState({tableLoading:true});
        fetch(API + "getstores")
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    deleteRow = (storeId) => {
        if(window.confirm("Tem a certeza que quer apagar esta loja?")){
            this.setState({tableLoading:true});
            fetch(API + 'deletestore&storeid=' + storeId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["store_" + storeId])).remove();
            });
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchstores&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData, config } = this.props;
        const stores = this.state.fetchData!=null ? this.state.fetchData.data : []
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'Name', active: true, numeric: false, label: 'Loja' },
                  { id: 'City', numeric: false, label: 'Localização' },
                  { id: 'GeneralEmail', numeric: false, label: 'Email' },
                  { id: 'GeneralPhone', numeric: false, label: 'Telemóvel' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="storesPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-building"></i> Lojas <span className="arrayCount">({stores.length})</span>
                            { (isAdmin || loginData.profile.Stores.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Loja"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Stores/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={stores.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(stores, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(store =>
                            <TableRow key={store.Id} className="tableRow" ref={"store_" + store.Id}>
                                <TableCell data-title="Loja" className="tableCell"><div className="smallColorDiv" style={{backgroundColor: store.Color}}></div> {store.Name} - {store.Shortname}</TableCell>
                                <TableCell data-title="Localização" className="tableCell">{store.City}</TableCell>
                                <TableCell data-title="Email" className="tableCell">{store.GeneralEmail}</TableCell>
                                <TableCell data-title="Telemóvel" className="tableCell">{store.GeneralPhone}</TableCell>
                                <TableCell data-title="Ativo" className="tableCell">{booleanConvert(store.IsActive)}</TableCell>
                                <TableCell data-title="Ações" className="tableCell actions actionsBig" data-row-id={store.Id}>
                                    {config.features.products && (isAdmin || (loginData.profile.Stores.permission === 1 && loginData.profile.StoreStock)) &&
                                        <Tooltip
                                            title={"Gerir inventário de loja"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Stores/StoreStock/"+store.Id}><i className="fa fa-cubes"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Stores.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Loja"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Stores/"+store.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {loginData.profile.Stores && loginData.profile.Stores.permission === 2 &&
                                        <Tooltip
                                            title={"Ver Loja"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Stores/"+store.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Stores.DEL) &&
                                        <Tooltip
                                            title={"Eliminar Loja"}
                                            enterDelay={200}>
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(store.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell >
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={stores.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Stores;
